/**
 * Helper used by Forum.jsx to work for any community (nuts/caps/shark).
 * Detects the community from the current URL pathname and reads the
 * corresponding token from localStorage. All internal forum links use
 * the same prefix so navigation stays inside the community.
 */
import { useLocation, useNavigate } from 'react-router-dom';

const KNOWN = ['nuts', 'caps', 'shark'];

export const detectCommunity = (pathname) => {
  const seg = (pathname || '').split('/').filter(Boolean)[0];
  return KNOWN.includes(seg) ? seg : 'nuts';
};

export const useForumCommunity = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const community = detectCommunity(location.pathname);
  const tokenKey = `${community}_token`;
  const getToken = () => localStorage.getItem(tokenKey);
  const basePath = `/${community}/forum`;
  const dashboardPath = `/${community}`;
  const goLogin = () => navigate(dashboardPath);
  return { community, getToken, basePath, dashboardPath, goLogin };
};
